import React, { Component, PropTypes } from 'react';

import {
  ColumnBold,
  TransformText,
  GriddleAction,
  DateFormatter,
  GridHeaderComponent
} from '../../../../components/utils/TableUtils';

import { NitroDataGrid } from 'nitro-components';

import { formatStatus } from '../helper';

import Status from '../../../../components/utils/Status';

class QuoteApprovalGrid extends Component {
  // Column definition for Driver allocation datagrid
  getColumnMetaData() {
    const columnMeta = [
      {
        columnName: 'QuoteId',
        displayName: 'Quote reference',
        sortable: true,
        customComponent: ColumnBold,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'CreatedBy',
        displayName: 'Created By',
        sortable: true,
        customComponent: TransformText,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'CreatedDate',
        displayName: 'Create Date',
        sortable: true,
        customComponent: DateFormatter,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'SubmittedDate',
        displayName: 'Submitted Date',
        sortable: true,
        customComponent: DateFormatter,
        customHeaderComponent: GridHeaderComponent
      },

      {
        columnName: 'CompanyName',
        displayName: 'Company Name',
        sortable: true,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'CostCentreCode',
        displayName: 'Cost Center Code',
        sortable: true,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'Status',
        displayName: 'Status',
        sortable: false,
        customComponent: ({ data }) => (
          <Status layout="horizontal" {...formatStatus(data)} />
        )
      },
      {
        columnName: '',
        displayName: ' ',
        sortable: false,
        customComponent: ({ data }) => <GriddleAction />
      }
    ];

    return columnMeta;
  }

  render() {
    return (
      <NitroDataGrid
        results={this.props.data}
        totalCount={this.props.total}
        rowPerPage={this.props.rowCount}
        columnMetaData={this.getColumnMetaData()}
        onRowClick={this.props.onRowClick}
        fetchExternalData={this.props.getExternalData}
        currentPage={this.props.currentPage}
        dataFetching={this.props.dataFetching}
        sortColumnAscendingCls="sort-column-ascending"
        sortColumnDescendingCls="sort-column-descending"
      />
    );
  }
}

QuoteApprovalGrid.propTypes = {
  data: PropTypes.array,
  total: PropTypes.number,
  rowCount: PropTypes.number,
  getExternalData: PropTypes.func,
  onRowClick: PropTypes.func,
  currentPage: PropTypes.number,
  dataFetching: PropTypes.bool
};

export default QuoteApprovalGrid;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteApprovalGrid.js